import { Component, Inject, OnInit } from '@angular/core';
import { Student } from 'src/app/core/models/student';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT, DatePipe } from '@angular/common';
import { TeacherBankInfo } from '../../core/models/teacherBankInfo';
import { TeacherBankInfoService } from '../../core/services/teacherBankInfo.service';
import { PaymentTracker } from '../../core/models/paymentTracker';
import { PaymentTrackerService } from '../../core/services/PaymentTracker.service';
import { Enrollment } from '../../core/models/enrollment';
import { EnrollmentService } from '../../core/services/enrollment.service';
import { Cart } from '../../core/models/cart';
import { CartService } from '../../core/services/cart.service';
import { AcademySettings } from '../../core/models/academy-settings';
import { AcademySettingsService } from '../../core/services/academy-settings.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent extends BaseComponent implements OnInit {

  tokenValid: boolean;
  isTeacher: string;
  studentId: number;

  thumbnail: string;
  courseName: string;
  price: number;
  userId: number;

  loading = false;
  payment = {} as any;

  emptyCart: boolean = false;
  thisPath: string;
  teacherId: number;
  cartItems = [] as Cart[];

  teacherBankInfos = [] as TeacherBankInfo[];

  selectedDiv: string | null = 'CreditCard';

  selectedBankData: string | null = null;
  paymentTracker = {} as PaymentTracker;

  enrollment = {} as Enrollment;
  academyToken: string;
  courseId: number;
  sumPrice: number;
  showLearnyBanlData: boolean = false;
  academySettings = [] as AcademySettings[];

  multiCoursesForOneTeacher: boolean = false;
  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private paymentService: PaymentService,
    private teacherBankInfoService: TeacherBankInfoService,
    private paymentTrackerService: PaymentTrackerService,
    private enrollmentService: EnrollmentService,
    public datepipe: DatePipe,
    private http: HttpClient, @Inject(DOCUMENT) private document: Document,
    private cartService: CartService,
    private academySettingsService: AcademySettingsService
  ) { super() }

  ngOnInit(): void {
    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher === 'false') { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.academyToken = localStorage.getItem('academyToken');
    this.thumbnail = localStorage.getItem('cartCourseThumbnail');
    this.courseName = localStorage.getItem('cartCourseName');
    this.price = Number(localStorage.getItem('cartCoursePrice'));
    this.userId = Number(localStorage.getItem('userId'));
    this.courseId = Number(localStorage.getItem('cartCourseId'));

    this.teacherId = Number(localStorage.getItem('cartCourseTeacher'));

    debugger


    this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        debugger;
        this.cartItems = data.result.returnData;
        this.sumPrice = this.cartItems.reduce((acc, item) => acc + item.price, 0);
        
        if (this.cartItems?.length === 0) {
          this.emptyCart = true;
          this.showLearnyBanlData = false; // Ensure this is set correctly
        } else {
          this.emptyCart = false;
    
          const allSameTeacher = this.cartItems.every(item => item.teacherId === this.cartItems[0].teacherId);
    
          if (this.cartItems?.length > 1 && !allSameTeacher) {
            this.showLearnyBanlData = false;
            this.academySettingsService.getAll().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.academySettings = data.result.returnData;
              }
            );
          } else if (this.cartItems?.length > 1 && allSameTeacher) {
            this.showLearnyBanlData = true;
            this.teacherBankInfoService.getTeacherBankInfoById(this.cartItems[0].teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.teacherBankInfos = data.result.returnData;
                console.log(this.teacherBankInfos)
                this.multiCoursesForOneTeacher = true;
              }
            );
          } else if (this.cartItems?.length === 1) {
            this.showLearnyBanlData = true;
            this.teacherBankInfoService.getTeacherBankInfoById(this.cartItems[0].teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.teacherBankInfos = data.result.returnData;
                this.multiCoursesForOneTeacher = false;
              }
            );
          }
        }
      }
    );
  }
  

  selectDiv(divName: string) {
    console.log('from popup',this.teacherBankInfos);
    this.selectedDiv = divName;

  }

  selectBank(bankAccountNo: string) {
    this.selectedBankData = bankAccountNo;
    this.paymentTracker.bnakAccountNo = bankAccountNo;
  }

  CloseBankdata() {
    this.selectedBankData = null;
  }



  savePayment() {
    debugger
    this.loading = true;
    this.payment.amount = this.sumPrice;
    this.payment.systemId = 5;
    this.payment.userId = this.userId;
    this.payment.paymentDate = new Date();

    if (this.selectedDiv === 'CreditCard') {
      this.paymentService.save(this.payment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          if (data.message.type === 'Success') {
            this.payment = data.returnData as any;
            this.document.location.href = this.payment.paymentUrl;
          }
          else {
            this.alertService.error(data.message.content);
          }
          this.loading = false;
        }
      )
    }
    else if (this.selectedDiv === 'BankTransfer') {
      this.paymentTracker.teacherId = this.cartItems[0].teacherId;
      this.paymentTracker.studentId = this.cartItems[0].studentId;
      this.paymentTracker.isPayed = false;
      this.paymentTracker.amount = this.cartItems[0].price.toString();
      this.paymentTracker.dateTime = new Date();
      this.paymentTracker.courseId = this.cartItems[0].courseId;

      this.paymentTrackerService.registerPaymentTracker(this.paymentTracker).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          if (data.result.message.type === "Success") {
            this.alertService.success(this.translate.instant('payedDone'));

            this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.cartItems = data.result.returnData;

                this.sumPrice = this.cartItems.reduce((acc, item) => acc + item.price, 0);
                if (this.cartItems?.length === 0) {
                  this.emptyCart = true;
                }
                else {
                  this.emptyCart = false;
                }
              }
            )
          }
          else {
            this.alertService.error(this.translate.instant('payisNotDone'))
          }
        }
      )
    }

  }

  removeFromCart(id: number) {
    debugger
    this.cartService.delete(id).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (response) => {
      },
      error: (err) => {
        console.error('Error deleting:', err);
      },
      complete: () => {
        this.alertService.success(this.translate.instant('courseDeleted'));
        this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            this.cartItems = data.result.returnData;
            this.router.navigate(['/cart']);

            this.sumPrice = this.cartItems.reduce((acc, item) => acc + item.price, 0);
            if (this.cartItems?.length === 0) {
              this.emptyCart = true;
            }
            else {
              this.emptyCart = false;
            }

            if (this.cartItems?.length > 1) {
              this.showLearnyBanlData = false;
            }
            else if (this.cartItems?.length === 1) {
              this.showLearnyBanlData = true;
            }
          }
        )
      }
    }
    )
  }

}
